type GetCardTypeParameters = {
  currentIndex: number;
  maximumCardIndex: number;
};

export function getCurrentDisplayType(parameters: GetCardTypeParameters) {
  const { currentIndex, maximumCardIndex } = parameters;

  if (currentIndex === maximumCardIndex) {
    return "newsletter-sign-up";
  }

  return "article";
}
